import styled from '@emotion/styled';
import {ListItemButton} from '@mui/material';

const LIST_ELEMENT_WRAPPER_HEIGHT = 500;
const LIST_ELEMENT_WRAPPER_WIDTH = 420;

import {
  mixinFlexboxColumn,
  mixinFlexboxRow,
  mixinOverflowY,
  mixinSubHeading,
  mixinSVGIcon,
} from '@ELib/styles/mixins';

export const PlaceholderCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: var(--font-size-small);
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--gutter);
  height: 100%;
  gap: var(--gutter);
  width: var(--dialog-large-width);
  font-size: var(--font-size-small);
`;

export const ListElementWrappers = styled.div`
  border: var(--regular-border-width) solid var(--color-core-primary);
  height: ${LIST_ELEMENT_WRAPPER_HEIGHT}px;
  width: ${LIST_ELEMENT_WRAPPER_WIDTH}px;
`;

export const SwitchButtonBox = styled.div`
  ${mixinFlexboxColumn}
  justify-content: center;
  align-items: center;
`;

export const StyledList = styled.ul`
  && .active {
    background: var(--color-state-active);
  }

  && .active:hover {
    background: var(--color-state-hover);
  }
  && > :hover {
    background: var(--color-state-hover);
  }

  svg {
    ${mixinSVGIcon}
    color: var(--color-core-grey);
  }
  > :hover svg {
    color: var(--color-core-black);
  }

  .active svg {
    color: var(--color-core-black);
  }

  height: 100%;
  padding: 0;
  margin: 0;
  ${mixinOverflowY}
  overflow-x: hidden;
`;

export const ButtonRow = styled.div`
  ${mixinFlexboxRow}
  gap: var(--gutter);
  justify-content: space-between;
`;

export const StyledListItemButton = styled(ListItemButton)`
  ${mixinFlexboxRow}
  justify-content: start;
  gap: var(--gutter);
  padding-left: 0;
  font-size: var(--font-size-small);
`;

export const ListsContainer = styled.div`
  ${mixinFlexboxRow}
  gap: var(--gutter-big);
`;

export const DialogHeading = styled.h2`
  ${mixinSubHeading}
  margin-bottom: var(--gutter);

  // styling for the close button
  margin-right: var(--gutter-big);
`;

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: var(--gutter-little);
  right: var(--gutter-little);
`;

export const WarningText = styled.div`
  color: var(--color-alerts-error);
`;
